import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { GoogleMap, Circle } from './googleMap';
const DEFAULT_SITE_RADIUS = 200;
const GoogleMapLocationSelection = ({ centre, siteRadius = DEFAULT_SITE_RADIUS, editable = true, zoom, onSiteRadiusChanged, onCentreChanged }) => {
    return (_jsx("div", { className: "google-map", children: _jsx(GoogleMap, { initialCenter: centre, center: centre, zoom: zoom, centerAroundCurrentLocation: false, children: _jsx(Circle, { radius: siteRadius || DEFAULT_SITE_RADIUS, editable: editable, lat: centre.lat, lng: centre.lng, onRadiusChanged: onSiteRadiusChanged, onCenterChanged: onCentreChanged }, "site") }) }));
};
export default GoogleMapLocationSelection;
